<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    label="Nome"
                    v-model="model.nome"
                    :validations="validations.nome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.grupoTipos"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoTipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :disabled="!model.isRegulado"
                    :label="false"
                    :options="form.regulacaoTipos"
                    :validations="validations.regulacaoTipo"
                    name="Tipo de regulação"
                    show-default-option
                    text-field="nome"
                    v-model="model.regulacaoTipoId"
                    value-field="id"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                @change="model.regulacaoTipoId = null"
                                v-model="model.isRegulado"
                            >
                                Regulado
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-select>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.impressaoMapaProducao"
                    :label="false"
                >
                    Impressão mapa de produção
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-area
            :title="index == null ? 'Cadastrar sub-grupo' : 'Alterar sub-grupo'"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col
                    class="flex-grow-1"
                >
                    <rkm-form-input
                        label="Nome"
                        v-model="subGrupo.nome"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        @click="add()"
                        color="primary"
                        :label="false"
                        >
                        {{ index == null ? 'Incluir' : 'Alterar' }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>


         <rkm-area
            title="Sub-grupos"
            v-if="index == null"
        >
            <rkm-table
                :items="items"
                :fields="fields"
                hide-filters
            >

                <template v-slot:cell(actions)="{ index, item }">
                    <rkm-button
                        color="primary"
                        title="Editar"
                        small
                        @click.stop="handleEdit(index, item)"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Excluir"
                        small
                        @click.stop="handleDestroy(index, item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>


            </rkm-table>
        </rkm-area>
    </rkm-form>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    max: 100,
                    min: 3,
                },
                regulacaoTipo: {
                    required: this.model.isRegulado,
                },
            }
        },
        items() {
            return this.model.subgrupos
        },
        fields(){
            return [
                { key: 'nome', label: 'Nome', class: 'align-middle' },
                { key: 'actions', label: 'Ações', class: 'col-min' }
            ]
        },
    },
    hasGrupo() {
        return true;
    },
    created() {

        this.repositories = {
            grupo: this.getConectaSusRepository('cadastro.grupo')
        }

        this.load()
    },
    data: () => ({
        model: null,
        subGrupo: {
            id: null,
            nome: null
        },
        index: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.grupo.edit(this.id)
                    .then(({ data }) => {

                        if (data.model) {

                            this.form = this.clone(data.form)
                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.grupo.create()
                    .then(({ data }) => {

                        if (data.model) {

                            this.form = this.clone(data.form)
                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        add() {

            const subGrupo = this.clone(this.subGrupo);

            const duplicado = this.model.subgrupos.find((sub, i)=>sub.nome == subGrupo.nome && i != this.index)

            if(subGrupo.nome == null) {
                this.showAlert('Informe o nome do sub-grupo.', 'Atenção')

                return false
            }

            if(duplicado) {
                this.showAlert('Já existe um sub-grupo com o nome informado.', 'Atenção')

                return false
            }

            if (this.index != null) {

                this.$set(this.model.subgrupos, this.index, this.clone(subGrupo))
            } else {

                this.model.subgrupos.push(this.clone(subGrupo))
            }

            this.subGrupo.nome = null;

            this.index = null;

        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.grupo.update(this.id, this.prepareData())
                        : this.repositories.grupo.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            if(this.id) {

                                this.showSaveNotification()
                                this.$emit('save', data)

                            } else {

                                const confirm = async () => {

                                    this.$emit('save', data)
                                }

                                const cancel = async () => {

                                    this.model.nome = null
                                    this.model.grupoTipoId = null
                                    this.model.isRegulado = false
                                    this.model.regulacaoTipoId = null
                                    this.model.impressaoMapaProducao = null
                                    this.model.subgrupos = []

                                }

                                const msg = 'Registro salvo com sucesso! Deseja voltar para a listagem?'

                                this.showConfirmation(msg, confirm, cancel)

                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.model)
        },
        handleDestroy(index, item) {

            const destroy = async () => {

                this.model.subgrupos.splice(index, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o sub-grupo <strong>${ item.nome }</strong>?`, destroy)
        },
        handleEdit(index, item) {

            this.subGrupo = this.clone(item);

            this.index = index;

        },
    },
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number },
    },
}
</script>